var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waitlist-other-products"},[_c('p',[_vm._v(_vm._s(_vm.$t('WaitlistOtherProducts.text')))]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('nuxt-link',{staticClass:"btn btn-primary btn-lg mx-auto",attrs:{"to":"/"}},[_vm._v("\n            "+_vm._s(_vm.$t('WaitlistOtherProducts.otherProductsButton'))+"\n        ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }